import { useState } from "react";
import type { UploadFile } from "antd/es/upload/interface";
import DualUpload from "./DualUpload";

const UploadPage: React.FC = () => {
    const [image, setImage] = useState<UploadFile | null>(null);
    const [pdf, setPdf] = useState<UploadFile | null>(null);

    return (
        <DualUpload
            image={image}
            pdf={pdf}
            onImageChange={setImage}
            onPdfChange={setPdf}
        />
    );
};

export default UploadPage;
